// extracted by mini-css-extract-plugin
export default {"cls1":"VeloPhoneNumberField-Menu_cls1__CIh8S","cls2":"VeloPhoneNumberField-Menu_cls2__IgXqC VeloPhoneNumberField-Menu_cls1__CIh8S"};